import { DateTime } from "luxon";
import React, { FC } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import {
  DateTimePicker,
  LocalizationProvider,
  pickersLayoutClasses,
} from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";

import { useGetOrg } from "../../api/organizations/get-organization";
import theme from "../../theme";

interface DateRangePickerProps {
  startFilter: DateTime | null;
  endFilter: DateTime | null;
  isStartValid: boolean;
  isEndValid: boolean;
  resourceMinTime: number;
  onTimeChange: (newVal: DateTime | null, filterType: "start" | "end") => void;
}

export const DateRangePicker = ({
  startFilter,
  endFilter,
  resourceMinTime,
  onTimeChange,
}: DateRangePickerProps) => {
  const org = useGetOrg();

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <Grid item container direction={"column"}>
        <Grid
          container
          direction={"row"}
          columnSpacing={1}
          rowSpacing={1}
          alignItems={"center"}
        >
          <Grid item>
            <DateTimePicker
              timezone={org?.data?.org?.timezone ?? "UTC"}
              slotProps={{
                digitalClockSectionItem: {
                  sx: {
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main} !important`,
                    },
                  },
                },
              }}
              disableFuture={true}
              minDateTime={DateTime.fromMillis(resourceMinTime)}
              label="Start Time"
              value={startFilter}
              onChange={(newValue) => {
                onTimeChange(newValue, "start");
              }}
            />
          </Grid>
          <Grid item>
            <IgTypography>to</IgTypography>
          </Grid>
          <Grid item>
            <DateTimePicker
              timezone={org?.data?.org?.timezone ?? "UTC"}
              slotProps={{
                digitalClockSectionItem: {
                  sx: {
                    "&.Mui-selected": {
                      backgroundColor: `${theme.palette.primary.main} !important`,
                    },
                  },
                },
              }}
              disableFuture={true}
              label="End Time"
              minDateTime={DateTime.fromMillis(resourceMinTime)}
              value={endFilter}
              onChange={(newValue) => {
                onTimeChange(newValue, "end");
              }}
            />
          </Grid>
        </Grid>
        <Grid item mt={1}>
          <IgTypography sx={{ fontSize: "13px" }}>
            <IgTypography sx={{ fontWeight: 600, fontSize: "13px" }}>
              Timezone:{" "}
            </IgTypography>
            {(org?.data?.org?.timezone || "").toUpperCase()}
          </IgTypography>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
};
